import { PROPS, SET_PROPS, MODAL, SET_MODAL, SET_ALERT, ALERT, AlertAction, ProjectAction, ModalAction } from './types'

const initialState: ProjectAction & ModalAction & AlertAction = {
  modal: {},
  alert: {},
  NOW:'',
  OWNER_END_DATE:'',
  OWNER_START_DATE:'',
}

export const propsReducer = (state = initialState, action: PROPS | MODAL | ALERT) => {
  const { type, payload } = action

  switch (type) {
    case SET_PROPS:
      return { ...state, ...payload }

    case SET_MODAL:
      return { ...state, ...payload }

    case SET_ALERT:
      return { ...state, ...payload }

    default:
      return state
  }
}
